/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import _ from 'lodash';
import {
  IConsumption,
  IDemand,
  IOtherCosts,
  IBillCategories,
  IBillDetails,
  IUtilityMeterDetails,
  IManageBillTableData,
  IBillDetailsForGas
} from './ManageUtilityBillConstants';
import moment from 'moment';

const consumption = {
  code: 'energy_charge',
  categoryName: 'Consumption',
  meterId: '',
  consumption: '',
  cost: ''
};

const consumptionForGas = {
  code: 'usage_charge',
  categoryName: 'Consumption',
  meterId: '',
  consumption: '',
  cost: ''
};

export const demand = {
  code: 'demand_charge',
  categoryName: 'Demand',
  meterId: '',
  demand: '',
  cost: ''
};

const otherCosts = [
  {
    code: 'service_charge',
    categoryName: 'Service Charges',
    cost: ''
  },
  {
    code: 'transmission_distribution_cost',
    categoryName: 'T&D Cost',
    cost: ''
  },
  {
    code: 'other_charges',
    categoryName: 'Others',
    cost: ''
  }
];

const otherCostsForGas = [
  {
    code: 'other_charges',
    categoryName: 'Others',
    cost: ''
  }
];

export const initialformData: IBillDetails = {
  // accountId: ' ', //Nullable, null for new entry
  logicalAccountId: '',
  startDate: '',
  endDate: '',
  billName: '', //Blank for new
  billingDate: '', //Blank for new,
  totalConsumption: '',
  totalDemand: '',
  totalCost: '',
  // currencyUnit: '',
  // consumptionUnit: '',
  // demandUnit: '',
  billCategories: {
    consumption: [consumption],
    demand: [demand],
    otherCosts: otherCosts
  },
  uploadedBill: null //TBD Base64
};

export const initialformDataForGas: IBillDetailsForGas = {
  // accountId: ' ', //Nullable, null for new entry
  logicalAccountId: '',
  startDate: '',
  endDate: '',
  billName: '', //Blank for new
  billingDate: '', //Blank for new,
  totalConsumption: '',
  totalCost: '',
  // currencyUnit: '',
  // consumptionUnit: '',
  // demandUnit: '',
  billCategories: {
    consumption: [consumptionForGas],
    // demand: [demand],
    otherCosts: otherCostsForGas
  },
  uploadedBill: null //TBD Base64
};

export const formmanageBillTableData = (
  data: IBillDetails,
  utilityType: string
) => {
  let serialNumber = 0;
  const modifiedColumns = Object.keys(data.billCategories).map(
    (bill: string) => {
      const obj: IAny = {};
      if (bill === 'consumption' || bill === 'demand') {
        serialNumber++;
        if (bill === 'consumption') {
          obj['categories'] = 'Consumption';
        } else if (bill === 'demand') {
          obj['categories'] = 'Demand';
        } else {
          console.log('logs');
        }

        obj['sr'] = serialNumber;
        if (
          data.billCategories[bill] &&
          data.billCategories[bill].length &&
          data.billCategories[bill].length > 0
        ) {
          obj['meterDetails'] = data.billCategories[
            bill as keyof IBillCategories
          ].map((cat: IAny) => {
            const subobj: IAny = {};
            if (!isNaN(cat.consumption) && bill === 'consumption') {
              subobj['consumption'] =
                cat.consumption === '' ? '' : Number(cat.consumption);
            } else if (!isNaN(cat.demand) && bill === 'demand') {
              subobj['demand'] = cat.demand === '' ? '' : Number(cat.demand);
            } else {
              console.log('logs');
            }
            subobj['cost'] = cat.cost === '' ? '' : Number(cat.cost);
            subobj['categories'] =
              cat.meterNumber === 'null' || cat.meterNumber === null
                ? cat.meterName + ' ( N/A )'
                : cat.meterName + ' ( ' + cat.meterNumber + ' )';
            subobj['meterId'] = cat.meterId;
            return subobj;
          });
        }

        if (bill === 'consumption') {
          if (
            (data.billCategories[bill] &&
              data.billCategories[bill].length &&
              data.billCategories[bill].some(
                (cons) => typeof cons.consumption === 'number'
              )) ||
            !isNaN(
              Number(
                data.totalConsumption === ''
                  ? 'undefined'
                  : data.totalConsumption
              )
            )
          ) {
            obj['consumption'] = data.billCategories[bill].reduce(
              (accumulator: number, currentValue: IConsumption) =>
                accumulator + Number(currentValue.consumption),
              0
            );
          } else {
            obj['consumption'] = '';
          }
        }
        if (bill === 'demand') {
          if (
            (data.billCategories[bill] &&
              data.billCategories[bill].length &&
              data.billCategories[bill].some(
                (dmnd: IAny) => typeof dmnd.demand === 'number'
              )) ||
            !isNaN(
              Number(data.totalDemand === '' ? 'undefined' : data.totalDemand)
            )
          ) {
            obj['demand'] =
              data.billCategories[bill] &&
              data.billCategories[bill].length &&
              data.billCategories[bill].reduce(
                (accumulator: number, currentValue: IDemand) =>
                  accumulator + Number(currentValue.demand),
                0
              );
          } else {
            obj['demand'] = '';
          }
        }
        if (
          (data.billCategories[bill as keyof IBillCategories] as IDemand[]) &&
          (data.billCategories[bill as keyof IBillCategories] as IDemand[])
            .length &&
          (data.billCategories[
            bill as keyof IBillCategories
          ] as IDemand[]).some((cst) => typeof cst.cost === 'number')
        ) {
          obj['cost'] = (data.billCategories[
            bill as keyof IBillCategories
          ] as IDemand[]).reduce(
            (accumulator: number, currentValue: IConsumption | IDemand) =>
              accumulator + Number(currentValue.cost),
            0
          );
        } else {
          obj['cost'] = '';
        }

        return obj;
      } else {
        let otherSerialNumber = serialNumber;
        return data.billCategories[bill as keyof IBillCategories].map(
          (cat: IOtherCosts) => {
            otherSerialNumber++;
            const subobj: IAny = {};
            if (cat.categoryName === 'T&D Cost') {
              subobj['categories'] = 'Transmission & Distribution';
            } else {
              subobj['categories'] = cat.categoryName;
            }

            subobj['cost'] = cat.cost === '' ? '' : Number(cat.cost);
            subobj['sr'] = otherSerialNumber;
            return subobj;
          }
        );
      }
    }
  );
  const totalObj: IAny = {};
  const flattenArr = _.flatten(modifiedColumns);
  totalObj['cost'] = flattenArr.reduce(
    (accumulator: number, currentValue: IAny) => {
      return accumulator + Number(currentValue.cost);
    },

    0
  );
  totalObj['cost'] = totalObj['cost'].toFixed(2);
  totalObj['categories'] = 'TOTAL BILL AMOUNT';
  flattenArr.push(totalObj);
  return flattenArr;
};

export const formBillDataNewEntry = (
  meterDetails: IUtilityMeterDetails[],
  formData: IBillCategories | IBillDetailsForGas,
  utilityType: string,
  utilityCellData?: IAny
) => {
  const tableData: IAny = formData;

  tableData.billCategories['consumption'] = meterDetails.map(
    (mtr: IUtilityMeterDetails) => {
      // const meterName = meterDetails.findIndex()
      if (utilityType === 'Electricity') {
        return {
          ...consumption,
          meterName: mtr.meterName,
          meterId: mtr.meterId,
          meterNumber: mtr.meterNumber
        };
      } else {
        return {
          ...consumptionForGas,
          meterName: mtr.meterName,
          meterId: mtr.meterId,
          meterNumber: mtr.meterNumber
        };
      }
    }
  );

  if (utilityType === 'Electricity') {
    tableData.billCategories['demand'] = meterDetails.map((mtr: IAny) => {
      return {
        ...demand,
        meterName: mtr.meterName,
        meterId: mtr.meterId,
        meterNumber: mtr.meterNumber
      };
    });
    tableData.billCategories['otherCosts'] = otherCosts;
  } else {
    tableData.billCategories['otherCosts'] = otherCostsForGas;
  }
  if (utilityCellData && utilityCellData.integrationType === 'Automatic') {
    tableData.consumptionUnit = utilityCellData.consumptionUnit;
    tableData.demandUnit = utilityCellData.demandUnit;
    tableData.currencyUnit = utilityCellData.currencyUnit;
  }
  return tableData;
};

export const formBillDataExisting = (
  tData: IBillDetails,
  meterDetails: IUtilityMeterDetails[],
  utilityType: string
) => {
  tData.billCategories['consumption'] = tData.billCategories['consumption'].map(
    (dt: IConsumption) => {
      if (dt.meterId) {
        const meterNumber =
          meterDetails[
            meterDetails.findIndex(
              (mtr: IUtilityMeterDetails) => mtr.meterId === dt.meterId
            )
          ].meterNumber;
        const meterName =
          meterDetails[
            meterDetails.findIndex(
              (mtr: IUtilityMeterDetails) => mtr.meterId === dt.meterId
            )
          ].meterName;
        return { ...dt, meterNumber: meterNumber, meterName: meterName };
      } else {
        const meterId =
          meterDetails[
            meterDetails.findIndex(
              (mtr: IUtilityMeterDetails) => mtr.meterNumber === dt.meterNumber
            )
          ].meterId;
        const meterName =
          meterDetails[
            meterDetails.findIndex(
              (mtr: IUtilityMeterDetails) => mtr.meterNumber === dt.meterNumber
            )
          ].meterName;
        return { ...dt, meterId: meterId, meterName: meterName };
      }
    }
  );

  if (utilityType === 'Electricity') {
    tData.billCategories['demand'] =
      tData.billCategories['demand'] &&
      tData.billCategories['demand'].length > 0 &&
      tData.billCategories['demand'].map((dt: IDemand) => {
        if (dt.meterId) {
          const meterNumber =
            meterDetails[
              meterDetails.findIndex(
                (mtr: IUtilityMeterDetails) => mtr.meterId === dt.meterId
              )
            ].meterNumber;
          const meterName =
            meterDetails[
              meterDetails.findIndex(
                (mtr: IUtilityMeterDetails) => mtr.meterId === dt.meterId
              )
            ].meterName;
          return { ...dt, meterNumber: meterNumber, meterName: meterName };
        } else {
          const meterId =
            meterDetails[
              meterDetails.findIndex(
                (mtr: IUtilityMeterDetails) =>
                  mtr.meterNumber === dt.meterNumber
              )
            ].meterId;
          const meterName =
            meterDetails[
              meterDetails.findIndex(
                (mtr: IUtilityMeterDetails) =>
                  mtr.meterNumber === dt.meterNumber
              )
            ].meterName;
          return { ...dt, meterId: meterId, meterName: meterName };
        }
      });
  }
  return tData;
};

export const modifyResponseFromAzure = (billDetails: IAny) => {
  const spltParam = billDetails.startDate.includes('to') ? 'to' : '-';
  const tempStartDate = billDetails.startDate;

  const tempEndDate = billDetails.endDate;
  billDetails.startDate = moment(tempStartDate.trim()).format('YYYY-MM-DD');
  billDetails.endDate = moment(tempEndDate.trim()).format('YYYY-MM-DD');
  billDetails.billName = moment(tempEndDate.trim(), 'YYYY-MM-DD').format(
    'MMM,DD'
  );
  billDetails.billDate = moment(tempEndDate.trim(), 'YYYY-MM-DD').format(
    'DD MMM,YYYY'
  );
  billDetails.isBillUploaded = true;
  billDetails.billCategories['consumption'] = billDetails.billCategories[
    'consumption'
  ].map((dt: IConsumption) => {
    const mtrNum = dt.meterId;
    delete dt.meterId;
    return {
      ...dt,
      meterNumber: mtrNum
    };
  });

  billDetails.billCategories['demand'] =
    billDetails.billCategories['demand'] &&
    billDetails.billCategories['demand'].length > 0 &&
    billDetails.billCategories['demand'].map((dt: IDemand) => {
      const mtrNum = dt.meterId;
      delete dt.meterId;
      return {
        ...dt,
        meterNumber: mtrNum
      };
    });

  return billDetails;
};

export const formSchemaFromTable = (
  data: IAny,
  formData: IBillDetails,
  utilityType: string
) => {
  const tCost: IAny = [];
  const consumptionData =
    data[data.findIndex((dt: IAny) => dt.categories === 'Consumption')];
  formData.billCategories['consumption'] = consumptionData.meterDetails?.map(
    (consp: IAny) => {
      tCost.push(Number(consp.cost));
      return {
        ...formData.billCategories.consumption[0],
        consumption: consp.consumption,
        cost: consp.cost,
        meterId: consp.meterId
      };
    }
  );
  formData['tConsumption'] = consumptionData.consumption;
  let serviceCharge: IAny;
  let tanddCharge: IAny;
  if (utilityType === 'Electricity') {
    const demandData =
      data[data.findIndex((dt: IAny) => dt.categories === 'Demand')];
    formData.billCategories['demand'] = demandData.meterDetails?.map(
      (consp: IAny) => {
        tCost.push(Number(consp.cost));
        return {
          ...formData.billCategories.demand[0],
          demand: consp.demand,
          cost: consp.cost,
          meterId: consp.meterId
        };
      }
    );
    formData['tDemand'] = demandData.demand;
    serviceCharge =
      data.findIndex((dt: IAny) => dt.categories === 'Service Charges') !==
        -1 &&
      data[data.findIndex((dt: IAny) => dt.categories === 'Service Charges')];
    tanddCharge =
      data.findIndex(
        (dt: IAny) => dt.categories === 'Transmission & Distribution'
      ) !== -1 &&
      data[
        data.findIndex(
          (dt: IAny) => dt.categories === 'Transmission & Distribution'
        )
      ];
  }

  const otherCharge =
    data.findIndex((dt: IAny) => dt.categories === 'Others') !== -1 &&
    data[data.findIndex((dt: IAny) => dt.categories === 'Others')];
  const totalCharge =
    data.findIndex((dt: IAny) => dt.categories === 'Total') !== -1 &&
    data[data.findIndex((dt: IAny) => dt.categories === 'Total')];
  const otherCost: IAny = formData.billCategories['otherCosts'].map(
    (othr: IAny) => {
      const obj = { ...othr };
      switch (othr.categoryName) {
        case 'Service Charges':
          tCost.push(Number(serviceCharge.cost));
          obj.cost = serviceCharge.cost;
          break;
        case 'T&D Cost':
          tCost.push(Number(tanddCharge.cost));
          obj.cost = tanddCharge.cost;
          break;
        case 'Others':
          tCost.push(Number(otherCharge.cost));
          obj.cost = otherCharge.cost;
          break;
        default:
          break;
      }

      return obj;
    }
  );

  formData.billCategories['otherCosts'] = otherCost;
  formData['tCost'] = tCost.reduce(
    (accumulator: IAny, currentValue: IAny) => accumulator + currentValue,
    0
  );
  formData['tCost'] = Number(formData['tCost']).toFixed(2);
  console.log('formData iss', formData);
  return formData;
};

export const convertToServerReadableFormat = (
  billData: IBillDetails,
  isNewBill: boolean,
  utilityType: string,
  pdfData?: IAny
) => {
  const formData: IAny = new FormData();
  Object.keys(billData).map((bill: string) => {
    if (bill !== 'billCategories' && bill !== 'uploadedBill') {
      formData.append(bill, billData[bill as keyof IBillDetails]);
    } else if (
      bill === 'uploadedBill' &&
      // utilityType === 'Electricity' &&
      billData[bill as keyof IBillDetails] &&
      billData[bill as keyof IBillDetails] !== null
    ) {
      formData.append(bill, pdfData, pdfData.name);
    } else {
      convertDynamicToFormData(billData[bill], formData);
      //   formData.append(
      //     'billCategories',
      //     convertDynamicToFormData(billData[bill], formData)
      //   );
    }
  });
  return formData;
};

export const convertDynamicToFormData = (
  billData: IBillCategories,
  formData: IAny
) => {
  Object.keys(billData).map((bill: IAny) => {
    if (
      billData[bill as keyof IBillCategories] &&
      billData[bill as keyof IBillCategories].length
    ) {
      switch (bill) {
        case 'consumption':
          billData[bill as keyof IBillCategories]
            .filter(
              (consp: IAny) => !isNaN(consp.consumption) && !isNaN(consp.cost)
            )
            .forEach((b: IAny, index: number) => {
              formData.append(
                `billCategories.consumptions[${index}].categoryCode`,
                b.code
              );
              formData.append(
                `billCategories.consumptions[${index}].categoryName`,
                b.categoryName
              );
              formData.append(
                `billCategories.consumptions[${index}].meterId`,
                b.meterId
              );
              formData.append(
                `billCategories.consumptions[${index}].consumption`,
                b.consumption
              );
              formData.append(
                `billCategories.consumptions[${index}].cost`,
                b.cost
              );
            });
          break;
        case 'demand':
          billData[bill as keyof IBillCategories]
            .filter((dmnd: IAny) => dmnd.demand && dmnd.cost)
            .forEach((b: IAny, index: number) => {
              formData.append(
                `billCategories.demands[${index}].categoryCode`,
                b.code
              );
              formData.append(
                `billCategories.demands[${index}].categoryName`,
                b.categoryName
              );
              formData.append(
                `billCategories.demands[${index}].meterId`,
                b.meterId
              );
              formData.append(
                `billCategories.demands[${index}].demand`,
                b.demand
              );
              formData.append(`billCategories.demands[${index}].cost`, b.cost);
            });
          break;
        case 'otherCosts':
          billData[bill as keyof IBillCategories]
            .filter((b: IAny) => b.cost)
            .forEach((b: IAny, index: number) => {
              formData.append(
                `billCategories.otherCosts[${index}].categoryCode`,
                b.code
              );
              formData.append(
                `billCategories.otherCosts[${index}].categoryName`,
                b.categoryName
              );
              formData.append(
                `billCategories.otherCosts[${index}].cost`,
                b.cost
              );
            });
          break;
        default:
          break;
      }
    }

    // if (typeof billData[bill] === 'object') {
    //   formData.append(
    //     bill,
    //     billData[bill].map((b: IAny) => convertToServerReadableFormat(b))
    //   );
    // }
  });
  return formData;
};
